import React, { useEffect, useState, useContext, memo } from "react";
import { PAGE_T } from "../../types";
import PageLooperContext from "../../providers/PageLooperContext";
import PageContentCategorieCommune from "./PageContentCategorieProvince";

const PrixCategorieParProvince: React.FC = memo(() => {
    const { pages, setPages, setCurrentIndex, apiData } = useContext(PageLooperContext);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            if (!apiData.length) {
                setLoading(false);
                return;
            }

            // Identifier toutes les catégories présentes
            const categories = Array.from(new Set(apiData.map((p) => p.produit.categorieProduit.libelle)));

            const newPages: any[] = [];

            categories.forEach((categorie) => {
                const catData = apiData.filter((p) =>p.produit.categorieProduit.libelle === categorie);

                // Map par région -> marché -> produit -> dernier prix
                const ProvinceMap = new Map<
                    string,
                    Map<string, { date: string; produits: { [produit: string]: number } }>
                >();

                catData.forEach((p) => {
                    const Province  = p.marche?.commune?.departement?.province.nom;
                    const marche = p.marche?.nomMarche;
                    const produit = p.produit.nomProduit;
                    const date = p.dateEnregistrement;
                    const prix = p.prixUnite1;
if (!Province || !marche || !produit || !prix) {
                        return;
                    }
                    if (!ProvinceMap.has(Province)) ProvinceMap.set(Province, new Map());
                     if (!produit || !marche || !Province ) {
                        return;
                    };
                    const marcheMap = ProvinceMap.get(Province)!;
                   
                    const exist = marcheMap.get(marche);
                    if (!exist || new Date(date) > new Date(exist.date)) {
                        marcheMap.set(marche, { date, produits: { [produit]: prix } });
                    } else if (exist && !exist.produits[produit]) {
                        exist.produits[produit] = prix;
                    }
                });

                // Créer une page pour chaque région
                Array.from(ProvinceMap.entries()).forEach(([Province, marcheMap]) => {
                    const allProduits = Array.from(new Set(catData.map((p) => p.produit.nomProduit)));
                    const tableRows = Array.from(marcheMap.entries()).map(([marche, info]) => {
                        const row: any = { marche, date: info.date };
                        allProduits.forEach((prod) => {
                            row[prod] = info.produits[prod] ?? "-";
                        });
                        return row;
                    });

                    // Vérifie si cette page existe déjà
                    const pageId = `cat-${categorie}-${Province}`;
                    if (!pages.some((p) => p.id === pageId)) {
                        newPages.push({
                            id: pageId,
                            component: (
                                <PageContentCategorieCommune
                                    categorie={categorie}
                                    province={Province}
                                    columns={["marche", "date", ...allProduits]}
                                    data={tableRows}
                                />
                            ),
                            duration: 15000,
                        });
                    }
                });
            });

            if (newPages.length) {
                // Supprimer la page de préchargement du produit
                setPages((prev: PAGE_T[]) => {
                    const filtered = prev.filter(
                        (p) => !(p.id === `PrixCategorieParProvince`)
                    );
                    return [...filtered, ...newPages];
                });
            }
            setLoading(false);
        };

        loadData();
    }, [pages, setPages, setCurrentIndex]);

    return null;
});

export default PrixCategorieParProvince;
